import { useEffect } from 'react';

// Browser-tab title, "No / SCAM - <Page>" everywhere (marketing site and
// dashboard share the format). Restores whatever was there on unmount so a
// page that sets nothing falls back to the previous title.
export const BRAND = 'No / SCAM';

export const formatPageTitle = (title) => (title ? `${BRAND} - ${title}` : BRAND);

export default function usePageTitle(title) {
  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = formatPageTitle(title);
    return () => {
      document.title = previous;
    };
  }, [title]);
}
